import React from "react";
import { ChatItem } from "../chat-item";

interface Props {
  items: any[];
}

const ChatList = ({ items = [] }: Partial<Props>) => {
  const renderedContent = items.map((item, index) => (
    <ChatItem key={index} {...item} />
  ));

  return <>{renderedContent}</>;
};

export default ChatList;
